import utils from "../common/util";

const cmpSideMenu = {
    component: null,

    /**
     * Initialise the Question Container
     * @param element
     */
    init: function (element)
    {
        utils.log('cmpSideMenu initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.menuTriggers = document.getElementsByClassName('settings-toggle-btn');

        _.component = element;

        _.onClickEvent(_.menuTriggers);

    },

    onClickEvent: function (elements)
    {
        const _ = this;

        for (let element of elements) {
            element.addEventListener('click', (e) =>
            {
                e.stopPropagation()
                if((e.target).classList.contains('settings-toggle-btn')) {
                    _.component.classList.toggle('active');
                }
            })
        }


    }


}

export default cmpSideMenu;
